<div>

  <div class="new-order-ui ">
    <div class=" py-2 bg-white">
      <div class="row m-0 justify-content-between">
        <div class="col-12 col-md-auto">
          <div class="h-100 d-flex align-items-center">
            <h3 class="page-title m-0">Service Orders</h3>
          </div>
        </div>
        <div class="col-12 col-md-auto">
          <div class="row">
            <div class="col px-0 pt-2 d-none">
              <label for="order-date" class="mr-2">Date</label></div>
            <div class="col font-weight-bold d-none">
              <input type="date" id="order-date" name="order-date" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <router-outlet></router-outlet>
</div>
